import * as React from 'react';

export interface TabProps {
    tabName?: string;
    tabIndex?: number;
    linkClassName?: string;
    iconClassName?: string;
    isActive?: boolean;
    onClick?(tabIndex: number);
    handleTabClickFromParent?(tabIndex: number);
    tabIsActive?(index: number);
    shouldShow?: any;
    arialabel?: string;
};


export interface TabsProps extends TabProps {
    defaultActiveTabIndex?: number;
}

export interface TabsState {
    activeTabIndex: number;
}

export class Tabs extends React.Component<TabsProps, TabsState> {

    constructor(props, context) {
        super(props, context);
        this.state = {
            activeTabIndex: 0
        };
        this.handleTabClick = this.handleTabClick.bind(this);
    }

    handleTabClick(tabIndex) {
        this.setState({
            activeTabIndex: tabIndex
        });
    }

    // Encapsulate <Tabs/> component API as props for <Tab/> children
    renderChildrenWithTabsApiAsProps() {
        return React.Children.map(this.props.children, (child, index) => {
            return React.cloneElement(child as React.ReactElement<any>, {
                onClick: this.handleTabClick,
                tabIndex: index,
                isActive: index === this.state.activeTabIndex
            });
        });
    }

    // Render current active tab content
    renderActiveTabContent() {
        const { children } = this.props;
        const { activeTabIndex } = this.state;
        if (children == null)
            return;

        if (children[activeTabIndex]) {
            return children[activeTabIndex].props.children;
        }
    }

    render() {
        return (
            <div className="tabs">
                <ul className="tabs-nav1 nav1 navbar-nav1 navbar-left1">
                    {this.renderChildrenWithTabsApiAsProps()}
                </ul>
                <div className="tabs-active-content">
                    {this.renderActiveTabContent()}
                </div>
            </div>
        );
    }
};

export class Tab extends React.Component<TabProps, {}> {
    static defaultProps: any;
    constructor(props, context) {
        super(props, context);
        this.handleTabClick = this.handleTabClick.bind(this);
        this.handleTabKeyUp = this.handleTabKeyUp.bind(this);
    }
    handleTabClick(event) {
        event.preventDefault();
        if (this.props.tabIndex != null) {
            if (this.props.onClick != null)
                this.props.onClick(this.props.tabIndex);
        }
        this.props.handleTabClickFromParent(this.props.tabIndex);
    }

    handleTabKeyUp(event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
            return;
        }

        event.preventDefault();
        if (this.props.tabIndex != null) {
            if (this.props.onClick != null)
                this.props.onClick(this.props.tabIndex);
        }
        this.props.handleTabClickFromParent(this.props.tabIndex);
    }

    render() {
        if (!this.props.shouldShow) {
            //no content shouldn't show tab
            return null;
        }
        return (
            <li className="tab">
                <a className={`tab-link ${this.props.linkClassName} ${this.props.isActive ? 'active' : ''}`}
                    onClick={this.handleTabClick}
                    tabIndex={0}
                    onKeyUp={this.handleTabKeyUp}
                    aria-label={this.props.arialabel}
                >
                    {/*<i className={`tab-icon ${this.props.iconClassName}`} />*/}
                    {this.props.tabName}
                </a>
            </li>
        );
    }
}
Tab.defaultProps = {
    shouldShow: true
};


